export const champsConsts = {
  ADD_CHAMP: "ADD_CHAMP",
  UPDATE_CHAMP: "UPDATE_CHAMP",
};

export default champsConsts;


// WEBPACK FOOTER //
// src/constants/champs.jsx